module.exports = __webpack_public_path__ + "img/server.4ad60a73.svg";